import { Divider, Link, MenuItem, Stack } from '@chronosphereio/chrono-ui';
import { SeriesMenuItemOptions } from '@/core';

export function TooltipContextMenu(props: { menuItemsActions: SeriesMenuItemOptions[]; clearPinned?: () => void }) {
  const { menuItemsActions, clearPinned = () => {} } = props;

  return (
    <div>
      <Divider />
      {menuItemsActions.map((m) => {
        const MenuItemComponent = (
          <MenuItem
            key={m.title}
            onClick={() => {
              m.onClick?.();
              clearPinned();
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <m.icon fontSize="inherit" />
              <div>{m.title}</div>
            </Stack>
          </MenuItem>
        );
        // Add the surrounding Link component if the href is defined
        if (m.href) {
          return (
            <Link href={m.href} target={m.target} key={m.title} sx={{ textDecoration: 'none' }}>
              {MenuItemComponent}
            </Link>
          );
        }
        return MenuItemComponent;
      })}
    </div>
  );
}
